import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
// @ts-ignore
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';

export const KnowledgebaseLayout = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    width: 100%;
    padding: 55px 0;
`;

export const Text = styled.span`
    font-weight: 500;
    margin: 20px 0;
`;

// ToDo Когда починят ссылку на одноклассники удалить стиль
export const Links = styled.span`
    overflow: hidden;
    width: 150px;
`;

export const Content = styled(GridContainer)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: nowrap;
    max-width: 985px;
`;

export const SBackBtn = styled(BaseButton)`
    padding-left: 0;
`;
